import React, { FC } from 'react';
import { useReactiveVar, useQuery } from '@apollo/client';
import { useEveryInHiddenPeriod } from 'app/containers/BasketResolver';
import { selectedPeriodVar } from 'app/apollo/reaction';
import TOP_MENU_DISH from 'app/graphql/network/menuDish';
import { isDateInRange } from 'app/utils/date';
import BasketCategoriesList from './components/BasketCategoriesList/BasketCategoriesList';
import BasketUpsellSelections from './components/BasketUpsellSelections/BasketUpsellSelections';
// import BasketGreenSelection from './components/BasketGreenSelection';

import css from './BasketNewUpsell.module.scss';
import BasketSetsSelection from './components/BasketSetsSelection';
// import BasketGreenSelection from './components/BasketGreenSelection';
import { useBigSetBannerByPeriod } from './useBigSetBannerByPeriod';
import { useFirstDishAvailablePeriod } from './useFirstDishAvailablePeriod';
import { BasketTopDishCard } from './components/BasketTopDishCard/BasketTopDishCard';

const topDishPeriods = ['2026-10-27'];

// const { data: menuDish } = useFragment({
//     fragment: gql`
//         fragment TOP_CARD_MENU_DISH on menuDish {
//             id,
//             price,
//             portions,

//         }
//     `,
//     from: {
//         __ref: 'menuDish:5433',
//     },
// });

// const TOP_DISH_ID = '5433';
const TOP_DISH_ID = '4695';

const BasketNewUpsell: FC = ({
    executeNeccessaryCartSaving = null,
    hidden = false,
    deliveryPeriod = undefined,
}: any) => {
    const setName = useBigSetBannerByPeriod();
    const period = useReactiveVar(selectedPeriodVar);

    const { firstAvailablePeriod, isLoading: isDishPeriodLoading } = useFirstDishAvailablePeriod(TOP_DISH_ID);

    const dishData = useQuery(TOP_MENU_DISH, {
        variables: { id: TOP_DISH_ID, period: firstAvailablePeriod },
        skip: !firstAvailablePeriod,
    });

    const isDishInCurrentPeriod = Boolean(dishData?.data?.menuDish)
        && firstAvailablePeriod === period;

    const isEveryHidden = useEveryInHiddenPeriod();
    if (isEveryHidden || hidden) {
        return null;
    }

    return (
        <div className={css.basketNewUpsellRoot}>
            <div className={css.basketUpsellTitle}>Добавить что-то</div>
            <BasketCategoriesList />
            <BasketUpsellSelections
                setName={setName}
                executeNeccessaryCartSaving={executeNeccessaryCartSaving}
            />
            {/* <BasketTopDishCard
                id={TOP_DISH_ID}
                isDishInCurrentPeriod={isDishInCurrentPeriod}
                targetPeriod={firstAvailablePeriod || undefined}
                isTargetPeriodLoading={isDishPeriodLoading || Boolean(dishData?.loading)}
                deliveryPeriod={deliveryPeriod}
            /> */}
            {/* <BasketSetsSelection
                setName={setName}
                executeNeccessaryCartSaving={executeNeccessaryCartSaving}
            /> */}

            {dishData?.data?.menuDish?.id && topDishPeriods.some((p) => isDateInRange(p, period, 1))
                ? (
                    <BasketTopDishCard
                        id={TOP_DISH_ID}
                        isDishInCurrentPeriod={isDishInCurrentPeriod}
                        targetPeriod={firstAvailablePeriod || undefined}
                        isTargetPeriodLoading={isDishPeriodLoading || Boolean(dishData?.loading)}
                        deliveryPeriod={deliveryPeriod}
                    />
                )
                : (
                    <BasketSetsSelection
                        setName={setName}
                        executeNeccessaryCartSaving={executeNeccessaryCartSaving}
                    />
                )}
        </div>
    );
};

export default BasketNewUpsell;
